const ColumnTypes = {
    text: 'text',
    link: 'link',
    external: 'external',
    date: 'date',
    datetime: 'datetime',
    component: 'component',
    badge: 'badge',
    button: 'button',
    numeric: 'numeric',
    nested: 'nested',
    complex: 'complex',
    checkbox: 'checkbox',
    'payment-card': 'payment-card',
};

export default ColumnTypes;
